export default {
    getRipsDetailHeader: (state) => state.ripsDetail.header,
    loadingDetail: (state) => state.ripsDetail.loading,
    ripsDetail: (state) => state.ripsDetail.body,
    ripsResult: (state) => state.ripsResult.body,
    ripsDetailError: (state) => state.ripsDetail.errorAlert,
    dashboardUrl: (state) => state.dashboardUrl.body,
    loadingDashboardUrl: (state) => state.dashboardUrl.loading,
    dashboardError: (state) => state.dashboardUrl.errorAlert
}